import { Component, OnInit, inject } from '@angular/core';
import { GlobalErrorHandlerService } from '../../services/global-error-handler.service';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { MatIcon } from '@angular/material/icon';
import { JsonPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-error-page',
    templateUrl: './app-error-page.component.html',
    styleUrls: ['./app-error-page.component.css'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions, MatIconButton, MatTooltip, CdkCopyToClipboard, MatIcon, JsonPipe, TranslateModule]
})
export class AppErrorPageComponent implements OnInit {
  private globalErrorHandlerService = inject(GlobalErrorHandlerService);

  error: any;
  rawError: any;

  ngOnInit(): void {
    this.error = this.globalErrorHandlerService.pop();
    this.rawError = JSON.stringify(this.error.stack);
  }
}
